import { render, staticRenderFns } from "./CreateInstPage.vue?vue&type=template&id=3ffc3314"
import script from "./CreateInstPage.js?vue&type=script&lang=js&external"
export * from "./CreateInstPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports